module.exports = __webpack_public_path__ + "static/img_4996-f2547606108b843cdb3377a07568fd68.webp";